import styles from './BrandLogo.module.css';
export type BrandName = 'google' | 'telegram' | 'cbe' | 'telebirr';
export function paymentBrand(provider: string, bankName?: string | null): BrandName | undefined {
  const name = `${provider} ${bankName ?? ''}`.toLowerCase();
  if (/tele[\s-]?birr/.test(name)) return 'telebirr';
  if (/\bcbe\b|commercial bank of ethiopia/.test(name)) return 'cbe';
  return undefined;
}
export function brandLogoUrl(brand: BrandName) { return `/brands/${brand}.${brand === 'cbe' ? 'png' : 'svg'}`; }
export function BrandLogo({ brand, size = 24 }: { brand?: BrandName; size?: number }) {
  if (!brand) return null;
  return <img className={styles.logo} src={brandLogoUrl(brand)} alt="" aria-hidden="true" width={brand === 'telebirr' ? Math.round(size * 1.8) : size} height={size} />;
}
